import React from 'react'

export default () => (
  <section id="message">
    <div className="section_title">
      <p>MESSAGE</p>
      <h2>ソルパックからのメッセージ</h2>
      <div className="title_label" />
    </div>
    <div className="section_contents">
      <p>IT企業での仕事をあきらめていませんか？<br />あなたのITスキルはアップデートできていますか？<br />第二新卒として新たなステップを踏み出したい方、<br />自分のキャリアをさらに生かして働きたい方<br />あなたの成長できる環境がSOLPACにあります。<br />日本の99％を占める中堅中小企業の様々な課題に<br />私たちSOLPACはITと共に挑み続けます。<br />お客様から「ありがとう」と一緒に言われる仲間との出会いを楽しみにしております。</p>
    </div>
  </section>
)


// WEBPACK FOOTER //
// ./src/Home/Message.js